import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface ChurnEventsFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const churnEvents = [
  { id: 'subscription_cancelled', name: 'Subscription Cancelled' },
  { id: 'package_expired', name: 'Package Expired' },
  { id: 'removed_as_client', name: 'Removed as Client' },
  { id: 'deleted_group_member', name: 'Removed from Group' },
];

export const ChurnEventsFilter: React.FC<ChurnEventsFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map((v) => churnEvents.find((option) => option.id === v)?.name || '')
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) => churnEvents.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={churnEvents}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? churnEvents.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Churn Events"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
